import React, { useEffect } from 'react';
import { PrimaryButton } from '@workday/canvas-kit-react/button';
import styles from './invitation.module.scss';
import { autoId } from '@workday/upc-common';
import { ID_INVITATION_BUTTON } from '../../../autoIds';
import { useEnrollmentEmailInitMutation } from '../../../slices/auth-api.slice';
import { useTranslation } from 'react-i18next';

export function Invitation({ invitation, steps }) {
    const { contactId, email } = invitation;
    const { t } = useTranslation('auth');

    // TODO no error handling here
    const [enrollmentEmailInit, { isLoading, isSuccess }] = useEnrollmentEmailInitMutation();

    useEffect(() => {
        if (isSuccess) {
            steps.next();
        }
    }, [steps, isSuccess]);

    function onSubmit() {
        enrollmentEmailInit({ contactId });
    }

    return (
        <div className={styles.container}>
            <h1 className={styles.verifyBody}>{t('Invitation.startByVerifying')}</h1>
            <p className={styles.email}>{email}</p>
            <PrimaryButton
                className={styles.button}
                disabled={isLoading}
                {...autoId(ID_INVITATION_BUTTON)}
                type='button'
                onClick={onSubmit}
                size='large'
                grow={true}>
                {t('Invitation.sendACode')}
            </PrimaryButton>
        </div>
    );
}
